var fontSizeAuto = function (oriWidth) {
	return function () {
		var viewportWidth = document.documentElement.clientWidth || document.body.clientWidth;

		if (viewportWidth > oriWidth) {
			viewportWidth = oriWidth;
		} else if (viewportWidth < 320) {
			viewportWidth = 320;
		}
		document.documentElement.style.fontSize = viewportWidth / (oriWidth / 100) + 'px';
	};
};
fontSizeAuto(750)();
window.onresize = fontSizeAuto(750);


//////////////////
// WEBPACK FOOTER
// ./config/rem.js
// module id = NGWz
// module chunks = 1